import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Immmu_Title } from '../../../../../utils/ES/Modals/SpotsModals';

const ModalImmmu = () => {
  return (
    <>
      <ModalVideo
        id="spot-immmu"
        dataText={Immmu_Title}
        videoSrc="https://player.vimeo.com/video/1208475847?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_IMMMU"
      />
    </>
  );
};

export default ModalImmmu;
